!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@hotmart/cosmos"] = r() : e["@hotmart/cosmos"] = r();
}(self, function () {
  return function () {
    "use strict";

    var e = {
      7705: function _(e) {
        e.exports = function (e) {
          var r = [];
          return r.toString = function () {
            return this.map(function (r) {
              var t = "",
                  i = void 0 !== r[5];
              return r[4] && (t += "@supports (".concat(r[4], ") {")), r[2] && (t += "@media ".concat(r[2], " {")), i && (t += "@layer".concat(r[5].length > 0 ? " ".concat(r[5]) : "", " {")), t += e(r), i && (t += "}"), r[2] && (t += "}"), r[4] && (t += "}"), t;
            }).join("");
          }, r.i = function (e, t, i, o, n) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (i) for (var s = 0; s < this.length; s++) {
              var c = this[s][0];
              null != c && (a[c] = !0);
            }

            for (var l = 0; l < e.length; l++) {
              var u = [].concat(e[l]);
              i && a[u[0]] || (void 0 !== n && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = n), t && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = t) : u[2] = t), o && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = o) : u[4] = "".concat(o)), r.push(u));
            }
          }, r;
        };
      },
      6742: function _(e) {
        e.exports = function (e, r) {
          return r || (r = {}), e ? (e = String(e.__esModule ? e.default : e), /^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), r.hash && (e += r.hash), /["'() \t\n]|(%20)/.test(e) || r.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e) : e;
        };
      },
      6738: function _(e) {
        e.exports = function (e) {
          return e[1];
        };
      },
      5097: function _(e, r, t) {
        t.d(r, {
          Z: function Z() {
            return s;
          }
        });
        var i = t(6738),
            o = t.n(i),
            n = t(7705),
            a = t.n(n)()(o());
        a.push([e.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
        var s = a;
      },
      1180: function _(e, r, t) {
        t.d(r, {
          Z: function Z() {
            return b;
          }
        });
        var i = t(6738),
            o = t.n(i),
            n = t(7705),
            a = t.n(n),
            s = t(6742),
            c = t.n(s),
            l = new URL(t(1450), t.b),
            u = a()(o()),
            d = c()(l);
        u.push([e.id, ":host{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--gray-100, #f7f9fa);border-color:var(--gray-300, #c9ced4);-webkit-border-radius:var(--spacer-8, 3rem);-moz-border-radius:var(--spacer-8, 3rem);border-radius:var(--spacer-8, 3rem);border-style:solid;border-width:var(--tag-border-width, 0.0625rem);color:var(--gray-700, #32363b);display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:var(--text-1, 0.75rem);font-weight:var(--font-weight, 400);line-height:var(--line-height-sm, 1);outline:0;padding:var(--tag-padding, 0.5rem 0.75rem);position:relative;text-decoration:none;-webkit-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-moz-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),border var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-webkit-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),-moz-box-shadow var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:baseline;white-space:nowrap}:host .hot-tag__close{background-color:var(--white, #ffffff);background-image:url(" + d + ");background-position:center center;background-repeat:no-repeat;-moz-background-size:50% auto;background-size:50% auto;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;cursor:pointer;display:block;height:var(--text-2, 1rem);opacity:.4;position:absolute;right:var(--spacer-2, 0.5rem);top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);width:var(--text-2, 1rem)}:host(.hot-tag--sm) .hot-tag__close{right:var(--spacer-1, 0.25rem)}:host(.hot-tag--lg) .hot-tag__close{height:var(--text-3, 1.25rem);right:var(--spacer-2, 0.5rem);width:var(--text-3, 1.25rem)}:host(:empty){display:none}:host([dismissible]){padding:var(--tag-padding-dismissable, 0.5rem 2rem 0.5rem 0.75rem)}:host([href]){background-color:var(--white, #ffffff);border-color:var(--gray-400, #9ea4ac);cursor:pointer}:host([href]:hover),:host([href]:focus){background-color:#e6e9ed;background-color:var(--gray-200);border-color:#9ea4ac;border-color:var(--gray-400);color:#32363b;color:var(--gray-700)}:host([href]:active){background-color:#c9ced4;background-color:var(--gray-300)}:host(.hot-tag--active){background-color:#9ea4ac;background-color:var(--gray-400);border-color:#9ea4ac;border-color:var(--gray-400);color:#fff;color:var(--white)}:host(.hot-tag--active[href]:hover),:host(.hot-tag--active[href]:focus){background-color:#9ea4ac;background-color:var(--gray-400);border-color:#9ea4ac;border-color:var(--gray-400);color:#fff;color:var(--white)}:host(.fade.show){display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}", ""]);
        var b = u;
      },
      1450: function _(e) {
        e.exports = "data:image/svg+xml,%3Csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 320 512%27%3E%3Cpath d=%27M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z%27/%3E%3C/svg%3E";
      }
    },
        r = {};

    function t(i) {
      var o = r[i];
      if (void 0 !== o) return o.exports;
      var n = r[i] = {
        id: i,
        exports: {}
      };
      return e[i](n, n.exports, t), n.exports;
    }

    t.m = e, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, {
        a: r
      }), r;
    }, t.d = function (e, r) {
      for (var i in r) {
        t.o(r, i) && !t.o(e, i) && Object.defineProperty(e, i, {
          enumerable: !0,
          get: r[i]
        });
      }
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.b = document.baseURI || self.location.href;
    var i = {};
    return function () {
      t.r(i);

      var e = require("@babel/runtime/helpers/classCallCheck");

      var r = t.n(e);

      var o = require("@babel/runtime/helpers/createClass");

      var n = t.n(o);

      var a = require("@babel/runtime/helpers/assertThisInitialized");

      var s = t.n(a);

      var c = require("@babel/runtime/helpers/get");

      var l = t.n(c);

      var u = require("@babel/runtime/helpers/inherits");

      var d = t.n(u);

      var b = require("@babel/runtime/helpers/possibleConstructorReturn");

      var m = t.n(b);

      var v = require("@babel/runtime/helpers/getPrototypeOf");

      var g = t.n(v);

      var h = require("@babel/runtime/helpers/wrapNativeSuper");

      var f = t.n(h),
          p = t(5097);

      var y = function (e) {
        d()(a, e);
        var t,
            i,
            o = (t = a, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              r = g()(t);

          if (i) {
            var o = g()(this).constructor;
            e = Reflect.construct(r, arguments, o);
          } else e = r.apply(this, arguments);

          return m()(this, e);
        });

        function a(e) {
          var t;
          r()(this, a);
          var i = (t = o.call(this)).getTemplate(),
              n = document.createElement("template");
          n.innerHTML = i;
          var s = n.content.querySelector("style");
          return s && (s.innerHTML = "".concat(s.innerHTML, " ").concat(p.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(n, e), t.attachShadow({
            mode: "open"
          }), t.shadowRoot.appendChild(document.importNode(n.content, !0)), t;
        }

        return n()(a, [{
          key: "connectedCallback",
          value: function value() {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "";
          }
        }]), a;
      }(f()(HTMLElement));

      var w = y;
      var k,
          x,
          z = "hot-tag",
          S = "dismiss",
          _ = "dismissible",
          E = t(1180);
      k = z, x = function (e) {
        d()(a, e);
        var t,
            i,
            o = (t = a, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              r = g()(t);

          if (i) {
            var o = g()(this).constructor;
            e = Reflect.construct(r, arguments, o);
          } else e = r.apply(this, arguments);

          return m()(this, e);
        });

        function a() {
          var e;
          return r()(this, a), (e = o.call(this, z)).dismiss = e.dismiss.bind(s()(e)), e;
        }

        return n()(a, [{
          key: "connectedCallback",
          value: function value() {
            l()(g()(a.prototype), "connectedCallback", this).call(this), this._addAccessibility(), this._handleDismissible();
          }
        }, {
          key: "attributeChangedCallback",
          value: function value(e) {
            e === _ && this._handleDismissible();
          }
        }, {
          key: "_handleDismissible",
          value: function value() {
            var e = this.shadowRoot.querySelector(".hot-tag__close"),
                r = this.hasAttribute(_);

            if (!e && r) {
              var t = document.createElement("div");
              return t.classList.add("hot-tag__close"), t.addEventListener("click", this.dismiss), void this.shadowRoot.appendChild(t);
            }

            e && !r && (e.removeEventListener("click", this.dismiss), e.remove());
          }
        }, {
          key: "_addAccessibility",
          value: function value() {
            this.hasAttribute("role") || this.setAttribute("role", "tag");
          }
        }, {
          key: "_startDismissAnimation",
          value: function value() {
            var e = this;
            this._toggleAnimationEvent("addEventListener", function r() {
              e._toggleAnimationEvent("removeEventListener", r), e.dispatchEvent(new CustomEvent(S)), e.parentNode && e.parentNode.removeChild(e);
            }), this.classList.remove("show");
          }
        }, {
          key: "_toggleAnimationEvent",
          value: function value(e, r) {
            this[e]("webkitTransitionEnd", r, !1), this[e]("oTransitionEnd", r, !1), this[e]("msAnimationEnd", r, !1), this[e]("transitionend", r, !1);
          }
        }, {
          key: "dismiss",
          value: function value() {
            var e = this.classList.contains("fade"),
                r = this.classList.contains("show");
            e && r ? this._startDismissAnimation() : (this.dispatchEvent(new CustomEvent(S)), this.parentNode && this.parentNode.removeChild(this));
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "\n      <style>".concat(E.Z.toString(), "</style>\n      <slot></slot>\n    ");
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return [_];
          }
        }]), a;
      }(w), customElements.get(k) || customElements.define(k, x);
    }(), i;
  }();
});